import { useQuery } from "@tanstack/react-query";
import type { TagsResponse } from "@guestbook/shared";
import { apiFetch, type ApiClientError } from "@/shared/lib/api";

const TAGS_KEY = "tags" as const;

/**
 * The current user's full tag set (name-sorted). Populates the contacts-list
 * filter's tag picker. Tags are a small per-user set, so this is unpaginated.
 */
export function useTags() {
  return useQuery<TagsResponse, ApiClientError>({
    queryKey: [TAGS_KEY, "list"],
    queryFn: () => apiFetch<TagsResponse>("/tags"),
  });
}
